"use client";

import { useState } from "react";
import { Button } from "@/components/themes/ui/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { AxiosPost_Nocatch } from "@/utilities/axioscall";
import { AK } from "@/constants";
import { handleSetCouponInfoStorageItems } from "@/utilities/storageManager";

interface CouponSectionProps {
  cartcouponlist: any[];
  setCartCouponList: (coupons: any[]) => void;
  displaycartcouponlist: any[];
  totalamount: number;
}

export default function CouponSection({
  cartcouponlist,
  setCartCouponList,
  displaycartcouponlist,
  totalamount,
}: CouponSectionProps) {
  const [showpromocodePopup, setShowPromocodePopup] = useState(false);
  const [showcouponsuccessPopup, setCouponSuccessPopup] = useState(false);
  const [hiddencouponinvalid, setHiddenCouponInvalid] = useState(true);
  const [hiddencouponinvalidmessage, setHiddenCouponInvalidMessage] = useState("Invalid Code");
  const [hiddencouponadded, setHiddenCouponAdded] = useState(true);
  const [couponAndGiftCardInput, setCouponAndGiftCardInput] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState<number | null>(0);
  const [loading, setLoading] = useState(false);

  return (
    <div className="">
      {displaycartcouponlist.length === 0 && (
        <div className="bg-[#EFF3FF] p-3 rounded-[8px] space-y-3">
          <p className="text-[12px] text-black font-medium">
            Whistles! Get extra INR:100 cashback on prepaid orders above Rs.699.
          </p>
          <Button
            onClick={() => {
              setHiddenCouponAdded(true);
              setHiddenCouponInvalid(true);
              setCouponAndGiftCardInput("");
              setShowPromocodePopup(true);
            }}
            className="bg-white text-primary font-medium rounded-[8px] border border-primary"
          >
            APPLY COUPON
          </Button>
        </div>
      )}

      {displaycartcouponlist.length > 0 && (
        <div className="space-y-3">
          <div className="flex gap-2 flex-wrap">
            {displaycartcouponlist.map((_coupon: any, index: number) => {
              const isAnyCouponApplied = cartcouponlist.length > 0;
              const isThisCouponApplied = cartcouponlist.some(
                (coupon: any) => coupon.code === _coupon?.code
              );

              return (
                <Button
                  key={index}
                  variant="outline"
                  className={`${selectedCoupon === index ? "border-primary" : ""} ${
                    isAnyCouponApplied && !isThisCouponApplied
                      ? "cursor-not-allowed opacity-50"
                      : "cursor-pointer"
                  }`}
                  onClick={() => {
                    if (!isAnyCouponApplied || isThisCouponApplied) {
                      setSelectedCoupon(index);
                      setHiddenCouponInvalid(true);
                      setHiddenCouponInvalidMessage("");
                    }
                  }}
                  disabled={isAnyCouponApplied && !isThisCouponApplied}
                >
                  {_coupon?.code}
                </Button>
              );
            })}
          </div>

          {selectedCoupon !== null && (
            <div className="space-y-2">
              <p className="text-sm">{displaycartcouponlist[selectedCoupon]?.description}</p>
              <div className="flex gap-3 items-end">
                <Button
                  onClick={async () => {
                    setLoading(true);
                    setHiddenCouponAdded(true);
                    setHiddenCouponInvalid(true);
                    setHiddenCouponInvalidMessage("");

                    const selectedCouponCode = displaycartcouponlist[selectedCoupon]?.code;
                    if (!selectedCouponCode) {
                      setHiddenCouponInvalid(false);
                      setHiddenCouponInvalidMessage("Invalid Code");
                      setLoading(false);
                      return;
                    }

                    let couponfilter = cartcouponlist.filter(
                      (_coupon: any) => _coupon?.code === selectedCouponCode
                    );

                    if (couponfilter.length > 0) {
                      setHiddenCouponAdded(false);
                      setLoading(false);
                      return;
                    }

                    let validatecoupondata: any = {};
                    let validatecoupon = await AxiosPost_Nocatch(
                      AK.VALIDATECOUPONSLISTAPI,
                      {
                        totalamount,
                        coupon_code: selectedCouponCode,
                      }
                    )
                      .then(async (res) => {
                        if (!res?.data?.success) {
                          setHiddenCouponInvalid(false);
                          setHiddenCouponInvalidMessage(
                            res?.data?.message || "Coupon is invalid."
                          );
                        } else {
                          validatecoupondata = res?.data?.data;
                        }
                        return res?.data?.success;
                      })
                      .catch(async (err) => {
                        setHiddenCouponInvalid(false);
                        setHiddenCouponInvalidMessage(
                          err?.response?.status === 422
                            ? err?.response?.data?.message ||
                              "Coupon is not valid at this time."
                            : "An error occurred. Please try again."
                        );
                        return false;
                      });

                    if (validatecoupon) {
                      const newCartCoupons = [validatecoupondata];
                      setCartCouponList(newCartCoupons);
                      handleSetCouponInfoStorageItems(newCartCoupons);
                      setShowPromocodePopup(false);
                      setCouponSuccessPopup(true);
                      setTimeout(() => setCouponSuccessPopup(false), 1000);
                    }

                    setLoading(false);
                  }}
                  disabled={
                    loading ||
                    cartcouponlist.some(
                      (coupon: any) => coupon.code === displaycartcouponlist[selectedCoupon]?.code
                    )
                  }
                >
                  {cartcouponlist.some(
                    (coupon: any) => coupon.code === displaycartcouponlist[selectedCoupon]?.code
                  ) ? (
                    "APPLIED"
                  ) : loading ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 100"
                      preserveAspectRatio="xMidYMid"
                      width="50"
                      height="50"
                      style={{ shapeRendering: "auto", display: "block", background: "transparent" }}
                    >
                      {[...Array(12)].map((_, i) => (
                        <g key={i} transform={`rotate(${i * 30} 50 50)`}>
                          <rect
                            fill="#fff"
                            height="12"
                            width="6"
                            ry="6"
                            rx="3"
                            y="24"
                            x="47"
                          >
                            <animate
                              repeatCount="indefinite"
                              begin={`-${(11 - i) / 12}s`}
                              dur="1s"
                              keyTimes="0;1"
                              values="1;0"
                              attributeName="opacity"
                            />
                          </rect>
                        </g>
                      ))}
                    </svg>
                  ) : (
                    "APPLY COUPON"
                  )}
                </Button>
                {cartcouponlist.some(
                  (coupon: any) => coupon.code === displaycartcouponlist[selectedCoupon]?.code
                ) && (
                  <Button
                    variant="ghost"
                    className="text-red-500 text-xs font-bold"
                    onClick={() => {
                      setCartCouponList([]);
                      handleSetCouponInfoStorageItems([]);
                      setHiddenCouponInvalid(true);
                      setHiddenCouponInvalidMessage("");
                    }}
                  >
                    REMOVE
                  </Button>
                )}
                <Button
                  variant="outline"
                  disabled={cartcouponlist.some(
                    (coupon: any) => coupon.code === displaycartcouponlist[selectedCoupon]?.code
                  )}
                  onClick={() => {
                    setHiddenCouponAdded(true);
                    setHiddenCouponInvalid(true);
                    setCouponAndGiftCardInput("");
                    setShowPromocodePopup(true);
                  }}
                >
                  CUSTOM COUPON
                </Button>
              </div>
              {!hiddencouponinvalid && hiddencouponinvalidmessage && (
                <p className="text-red-500 text-sm">{hiddencouponinvalidmessage}</p>
              )}
            </div>
          )}
        </div>
      )}

      {showpromocodePopup && (
        <div className="fixed h-full w-full inset-0 p-4 bg-black bg-opacity-50 flex z-30 items-center justify-center">
          <div className="bg-white p-6 rounded-lg max-w-md w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Apply Coupon</h3>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => {
                  setHiddenCouponAdded(true);
                  setHiddenCouponInvalid(true);
                  setCouponAndGiftCardInput("");
                  setShowPromocodePopup(false);
                }}
              >
                <FontAwesomeIcon icon={faXmark} />
              </Button>
            </div>
            <div className="space-y-4">
              <input
                type="text"
                className="w-full border rounded-md p-2 focus:border-solid focus:border-primary"
                placeholder="ENTER CODE"
                value={couponAndGiftCardInput}
                onChange={(e) => setCouponAndGiftCardInput(e.target.value.toUpperCase())}
                autoFocus
              />
              {!hiddencouponinvalid && (
                <p className="text-red-500 text-sm">{hiddencouponinvalidmessage}</p>
              )}
              {!hiddencouponadded && (
                <p className="text-red-500 text-sm">Coupon Already Added!</p>
              )}
              <Button
                className="w-full bg-primary text-white"
                onClick={async () => {
                  setHiddenCouponAdded(true);
                  setHiddenCouponInvalid(true);
                  if (couponAndGiftCardInput === "") {
                    setHiddenCouponInvalid(false);
                    setHiddenCouponInvalidMessage("Invalid Code");
                    return;
                  }

                  let couponfilter = cartcouponlist.filter(
                    (_coupon: any) => _coupon?.code === couponAndGiftCardInput
                  );

                  if (couponfilter.length > 0) {
                    setHiddenCouponAdded(false);
                    return;
                  }

                  let validatecoupondata: any = {};
                  let validatecoupon = await AxiosPost_Nocatch(
                    AK.VALIDATECOUPONSLISTAPI,
                    {
                      totalamount,
                      coupon_code: couponAndGiftCardInput,
                    }
                  )
                    .then(async (res) => {
                      if (!res?.data?.success) {
                        setHiddenCouponInvalid(false);
                        setHiddenCouponInvalidMessage(res?.data?.message || "Coupon is invalid.");
                      } else {
                        validatecoupondata = res?.data?.data;
                      }
                      return res?.data?.success;
                    })
                    .catch(async (err) => {
                      setHiddenCouponInvalid(false);
                      setHiddenCouponInvalidMessage(
                        err?.response?.data?.message || "An error occurred. Please try again."
                      );
                      return false;
                    });

                  if (validatecoupon) {
                    const newCartCoupons = [...cartcouponlist, validatecoupondata];
                    setCartCouponList(newCartCoupons);
                    handleSetCouponInfoStorageItems(newCartCoupons);
                    setShowPromocodePopup(false);
                    setCouponSuccessPopup(true);
                    setTimeout(() => setCouponSuccessPopup(false), 1000);
                  }
                }}
              >
                APPLY
              </Button>
            </div>
          </div>
        </div>
      )}

      {showcouponsuccessPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex z-30 items-center justify-center">
          <div className="bg-white p-6 rounded-lg max-w-md w-full text-center">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              className="w-16 h-16 mx-auto"
            >
              <circle
                className="path circle"
                fill="none"
                stroke="#fdd734"
                strokeWidth={8}
                strokeMiterlimit={10}
                cx="65.1"
                cy="65.1"
                r="60.1"
              />
              <polyline
                className="path check"
                fill="none"
                stroke="#fdd734"
                strokeWidth={8}
                strokeLinecap="round"
                strokeMiterlimit={10}
                points="100.2,40.2 51.5,88.8 29.8,67.5 "
              />
            </svg>
            <p className="mt-4 text-lg">Coupon Applied Successfully!</p>
          </div>
        </div>
      )}
    </div>
  );
}